/*
 * IGNIERE §280 自己点検（2026-10-07）色・サイズを替えた直後の「カートに追加」で、明細の属性（発送）が落ちる件の直し。
 * 原因＝Horizon の本体（assets/product-form.js handleSubmit）は、選択の切り替えの読み込み中（#variantChangeInProgress）に
 *   押された追加を「近道」で処理し、読み込みの後に商品の番号と数だけを JSON で送る（#processBatchAddToCart）。
 *   フォームを使わないので、フォームに付けた properties[発送]
 *   （特商法の最終確認画面に出す引渡時期と返品の条件・§214／§272）が付かない。
 *   実測＝替えてから 0.3〜1.2 秒で押すと毎回落ち、2 秒後なら付く（スマホ・PC とも）。
 * 直し＝Horizon の本体は触らず、その近道の送信（JSON で items を送る /cart/add）にだけ、
 *   ページにある「発送」の値を足す。フォームで送る通常の経路（FormData）は元から付くので触らない。
 *   ⚠ 最初は「読み込みが終わるまで送信を待たせる」作りにしたが、合図の取り方の隙間で 24 回中 2〜4 回漏れた
 *   ＝落ちる場所（近道の送信）そのものを直す作りに替えた。
 *   「発送」の値は商品ごと（お届けの型）で、同じ商品の色・サイズでは変わらない＝ページの値をそのまま足してよい。
 *   値のある所＝商品ページ（templates/product.json の ig_delivery_points の hidden input）だけ。無いページでは何もしない。
 */
(function () {
  if (window.__igAddProps) return;
  window.__igAddProps = true;
  var orig = window.fetch;
  if (typeof orig !== 'function') return;

  function addUrl() {
    var r = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add';
    return r.replace(/\.js$/, '');
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var body = init && init.body;
      if (typeof body === 'string' && url.indexOf(addUrl()) !== -1 && body.charAt(0) === '{') {
        var el = document.querySelector('input[name="properties[発送]"]');
        if (el && el.value) {
          var data = JSON.parse(body);
          if (data && Array.isArray(data.items)) {
            var changed = false;
            data.items.forEach(function (it) {
              if (!it.properties || !it.properties['発送']) {
                it.properties = Object.assign({}, it.properties || {}, { '発送': el.value });
                changed = true;
              }
            });
            if (changed) init = Object.assign({}, init, { body: JSON.stringify(data) });
          }
        }
      }
    } catch (_) { /* 足せなくても買い物は止めない */ }
    return orig.call(this, input, init);
  };
})();
